"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M3 7.663A4.663 4.663 0 0 1 7.663 3h8.674A4.663 4.663 0 0 1 21 7.663v2.336a.694.694 0 0 1-1.389 0V8.542H4.39v7.795a3.274 3.274 0 0 0 3.274 3.274H12A.694.694 0 1 1 12 21H7.663A4.663 4.663 0 0 1 3 16.337zm1.428-.51h15.144a3.275 3.275 0 0 0-3.235-2.764H7.663a3.275 3.275 0 0 0-3.235 2.764m4.893 8.866a.893.893 0 1 1-1.786 0 .893.893 0 0 1 1.786 0m-.893-3.126a.893.893 0 1 0 0-1.786.893.893 0 0 0 0 1.786",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M19.572 7.153a3.274 3.274 0 0 0-3.235-2.764H7.663a3.274 3.274 0 0 0-3.235 2.764zM8.428 15.92a.099.099 0 1 0 0 .198.099.099 0 0 0 0-.198m0-4.019a.099.099 0 1 0 0 .198.099.099 0 0 0 0-.198M7.663 3A4.663 4.663 0 0 0 3 7.663v8.674A4.663 4.663 0 0 0 7.663 21H12a.695.695 0 0 0 0-1.389H7.663a3.274 3.274 0 0 1-3.274-3.274V8.542H19.61v1.457a.694.694 0 1 0 1.389 0V7.663A4.663 4.663 0 0 0 16.337 3zm.765 13.912a.893.893 0 1 0 0-1.786.893.893 0 0 0 0 1.786M9.32 12a.893.893 0 1 1-1.786 0 .893.893 0 0 1 1.786 0",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M14.576 12.37c.289.25.32.69.068.979l-.941 1.082h4.99l-.942-1.082a.694.694 0 1 1 1.048-.912l1.941 2.233a.694.694 0 0 1 0 .912l-1.94 2.232a.695.695 0 0 1-1.049-.911l.941-1.083h-4.99l.942 1.083a.694.694 0 0 1-1.048.911l-1.941-2.232a.695.695 0 0 1 0-.912l1.94-2.232a.695.695 0 0 1 .98-.069",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=TimescaleIcon24.js.map